var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPlusCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3D9BD6",
    fillRule: "nonzero",
    d: "M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm0 22.6C6.146 22.6 1.4 17.854 1.4 12 1.4 6.146 6.146 1.4 12 1.4c5.854 0 10.6 4.746 10.6 10.6-.008 5.851-4.749 10.592-10.6 10.6zm.8-11.4V6.4h-1.6v4.8H6.4v1.6h4.8v4.8h1.6v-4.8h4.8v-1.6h-4.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlusCircle);
export default __webpack_public_path__ + "static/media/icon-plus-circle.b374f2586f1f00895affd9870b130481.svg";
export { ForwardRef as ReactComponent };